import React from 'react'
import { useRecoilState } from 'recoil'
import { Modal } from '../../common'
import ProductVariationsTable from '../table/ProductVariationsTable'
import { productVariationsModalState } from './productVariationsModalState'

import './product_variations_modal.scss'

export const ProductVariationsModal = ({ variations, setProductVariation }) => {
  const [display, setDisplay] = useRecoilState(productVariationsModalState)

  if (!variations.length) {
    return <></>
  }

  return (
    <Modal display={display} setDisplay={setDisplay}>
      <ProductVariationsTable variations={variations} setProductVariation={setProductVariation} />
    </Modal>
  )
}

export default ProductVariationsModal